import React, { useContext } from 'react';
import { BrandingContext, ContractContext } from '../contexts/ContractContext';
import { HWAHeader } from './HWAHeader/HWAHeader';
import { Header } from '../Header';
import DTCHeader from './DTCHeader/DTCHeader';
import NJRHeader from './NJRHeader/NJRHeader';
import AppleHeader from './AppleHeader/AppleHeader';

export const HeaderController = () => {
    const branding = useContext(BrandingContext);
    const { clientId } = branding;

    switch (clientId?.toLowerCase()) {
        case 'njr':
            return <NJRHeader />;
        case 'dtc':
            return <DTCHeader />;
        case 'apple':
            return <AppleHeader />;
        default:
            return <AppleHeader />;
    }
};
